import { hasRequiredPermission } from '@common/utils'
import { MolsonBox, MolsonLink } from '@components/reusable'
import { Link, useLocation } from 'react-router-dom'

export type RouteProps = {
  pageName: string
  path: string
  permissionKey?: string
  search?: string
}

export type LinksProps = {
  routes: RouteProps[]
}

const Links = ({ routes }: LinksProps) => {
  const location = useLocation()

  return (
    <MolsonBox sx={{ display: 'flex', gap: 0.5 }}>
      {routes.map(route => {
        if (!hasRequiredPermission(route?.permissionKey ?? [])) {
          return null
        }

        let isActive = false

        if (
          location.pathname === route.path ||
          location.pathname.includes(route.path)
        ) {
          isActive = true
        }

        const path = route.search ? `${route.path}${route.search}` : route.path

        return (
          <MolsonLink
            component={Link}
            isActive={isActive}
            key={`${route.path}-${route.pageName}-${route.permissionKey}`}
            to={path}
          >
            {route.pageName}
          </MolsonLink>
        )
      })}
    </MolsonBox>
  )
}

export { Links }
